import React from 'react';
import ServicePage from './ServicePage';
import { IconFileText, IconLeaf, IconShieldCheck } from '../../components/Icons';

const DATA = {
  icon: <IconFileText size={32} />, category: 'ambiental',
  title: 'Licencias Ambientales',
  subtitle: 'Gestión integral de licencias ambientales ante el ANLA y corporaciones autónomas regionales.',
  norm: 'Ley 99/1993 – Decreto 2041 de 2014',
  desc: 'Acompañamos a nuestros clientes en todo el proceso de obtención, modificación y seguimiento de licencias ambientales ante el ANLA y corporaciones autónomas regionales, desde el diagnóstico inicial hasta la aprobación final.',
  details: [
    'Elaboración del Estudio de Impacto Ambiental (EIA)',
    'Diagnóstico Ambiental de Alternativas (DAA)',
    'Elaboración de términos de referencia',
    'Acompañamiento en audiencias públicas ambientales',
    'Trámites ante ANLA y corporaciones autónomas',
    'Modificación, actualización y seguimiento post-licencia',
  ],
  related: [
    { icon: <IconLeaf size={18} />,        label: 'PMA',  path: '/servicios/pma' },
    { icon: <IconShieldCheck size={18} />, label: 'ICAS', path: '/servicios/icas' },
  ],
};

export default function Licencias() { return <ServicePage data={DATA} />; }
